'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPowerOutline = function TiPowerOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.2 10.1c-1.4-1.4-3.3-1.7-5-1.2v-0.6c0-2.7-2.3-5-5-5s-5 2.3-5 5v0.6c-1.7-0.5-3.7-0.2-5.1 1.2-2.6 2.7-4.1 6.2-4.1 10s1.5 7.4 4.2 10c2.6 2.7 6.2 4.2 10 4.2s7.3-1.5 10-4.2c2.7-2.6 4.1-6.2 4.1-10s-1.4-7.3-4.1-10z m-11.7-1.8c0-0.9 0.7-1.6 1.7-1.6s1.6 0.7 1.6 1.6v8.4c0 0.9-0.7 1.6-1.6 1.6s-1.7-0.7-1.7-1.6v-8.4z m-1.7 6.4v2c0 1.8 1.5 3.3 3.4 3.3s3.3-1.5 3.3-3.3v-2c0.2 0.5 0.4 0.9 0.8 1.3 1.1 1.1 1.7 2.6 1.7 4.1s-0.6 3-1.7 4.1c-2.2 2.2-6.1 2.2-8.3 0-1.1-1.1-1.7-2.5-1.7-4.1s0.6-3 1.7-4.1c0.4-0.4 0.7-0.8 0.8-1.3z m11 13.1c-2 2-4.7 3.2-7.6 3.2s-5.6-1.2-7.7-3.2c-2-2.1-3.2-4.8-3.2-7.7s1.2-5.6 3.2-7.6c0.7-0.7 1.7-0.7 2.4 0s0.6 1.7 0 2.3c-1.5 1.4-2.2 3.3-2.2 5.3s0.7 3.9 2.2 5.3c1.4 1.4 3.3 2.2 5.3 2.2s3.9-0.8 5.3-2.2c1.4-1.4 2.2-3.3 2.2-5.3s-0.8-3.9-2.2-5.3c-0.7-0.6-0.7-1.7 0-2.3s1.7-0.7 2.3 0c2.1 2 3.2 4.7 3.2 7.6s-1.1 5.6-3.2 7.7z' })
        )
    );
};

exports.default = TiPowerOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/power-outline.js
// module id = 2152
// module chunks = 0